import React from 'react'

export const useFocus = (
    inputRef: React.RefObject<HTMLInputElement | null>
): any =>
    React.useEffect(() => {
        if (inputRef?.current) inputRef.current.focus()
    }, [inputRef])
